import {
  createColumnHelper,
  createSortedRowModel,
  rowSortingFeature,
  sortFns,
  tableFeatures,
  type ColumnDef,
  type RowData,
} from '@tanstack/react-table';

/**
 * DataTable 기능 세트(TanStack Table v9) — 모듈 스코프 고정. 컬럼 정의는 `createColumns<T>()` 헬퍼로 만든다.
 * 정렬은 클라이언트(현재 페이지 내) — 서버 정렬이 필요해지면 manualSorting + onSortingChange 로 확장.
 */
export const dataTableFeatures = tableFeatures({
  rowSortingFeature,
  sortedRowModel: createSortedRowModel(),
  sortFns,
});
export type DataTableFeatures = typeof dataTableFeatures;
// eslint-disable-next-line @typescript-eslint/no-explicit-any
export type DataTableColumn<TData extends RowData> = ColumnDef<DataTableFeatures, TData, any>;

/** 타입 안전 컬럼 헬퍼 — `const col = createColumns<Company>(); col.accessor('name', { header: '업체명' })`. */
export function createColumns<TData extends RowData>() {
  return createColumnHelper<DataTableFeatures, TData>();
}
